export const changeMemberUlErrorStatusMessages = {
  404: "Пользователь с таким ИНН не найден",
  418: "Сожалеем, но наши бэкендеры - чайники",
};
